<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>测试管理</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{  lessonInfo.manager &&  lessonInfo.manager ? lessonInfo.manager.name : '' }}</p>
        </div>
        <div class="course_btn">
          <!-- <router-link
            tag="div"
            :to="'/www/lesson_detail?id=' + lessonInfo.id"
            class="add-btn"
          >预览</router-link> -->
          <div
            v-if="lessonInfo.status==0"
            class="add-btn"
            @click="$parent.saveOnline(lessonInfo.title, lessonInfo.id)"
          >提交审核</div>
        </div>
      </div>
      <div class="list">
        <form id="itemForm">
          <div class="item">
            <div>
              <span class="label"><i class="require">*</i>测试标题:</span>
              <input
                class="s-select separate"
                type="text"
                v-model="formInfo.title"
                autocomplete="off"
                maxlength="25"
              >
            </div>
          </div>
          <div class="item">
            <div class="item-minute">
              <span class="label"><i class="require">*</i>测试时间:</span>
              <div class="minute">
                <input
                  class="s-select separate"
                  type="number"
                  v-model="formInfo.examMinutes"
                  autocomplete="off"
                  max="299"
                >
                <span>分钟</span>
              </div>
            </div>
            <div class="item-minute">
              <span class="label"><i class="require">*</i>测试开始时间:</span>
              <input
                class="s-select separate"
                type="datetime-local"
                v-model="formInfo.startTime"
                :min="lessonInfo.startTime || nowDate"
                :max="lessonInfo.endTime"
              >
            </div>

          </div>
          <div class="item">
            <div class="item-minute">
              <span class="label"><i class="require">*</i>测试截止时间:</span>
              <input
                class="s-select separate"
                type="datetime-local"
                v-model="formInfo.endTime"
                :min="formInfo.startTime"
                :max="lessonInfo.endTime"
              >
            </div>
            <div class="item-minute">
              <span class="label"><i class="require">*</i>显示成绩时间:</span>
              <input
                class="s-select separate"
                type="datetime-local"
                v-model="formInfo.answerTime"
                :min="formInfo.endTime"
              >
            </div>
          </div>
          <div class="item">
            <span class="label"><i class="require">*</i>测试说明:</span>
            <div class="tips">
              <textarea
                class="s-select separate"
                id=""
                cols="123"
                rows="10"
                v-model="formInfo.des"
                maxlength="1000"
              ></textarea>
              <span>还可以输入{{formatNum(1000,formInfo.des)}}字</span>
            </div>
          </div>
        </form>
      </div>
      <div class="course_info">
        <div class="panel-title">
          <p>测试试题</p>
        </div>
        <div class="course_btn">
          <div @click="showAddWindow">添加试题</div>
        </div>
      </div>
      <div class="list">
        <div class="topic">
          <div class="topic-title">单选题（共{{singleChoiceData.length}}题）</div>
          <div
            class="option"
            v-for="(item,index) in singleChoiceData"
            :key="index"
          >
            <div class="option-title">
              <div>
                <span>{{index+1}}、</span>
                <span v-html="item.onlineQuestion.content"></span>
                <span>({{Number(item.onlineQuestion.grade)}}分)</span>
              </div>
              <span @click="delQuestion(item.id)">删除</span>
            </div>
            <div
              v-for="(option,keys) in item.onlineQuestion.option"
              :key="option.id"
            ><input
                type="radio"
                value="0"
                disabled
              ><span>{{letter[keys]}}.{{option.title}}</span></div>
            <div class="answer">正确答案:<span
                v-for="(option,keys) in item.onlineQuestion.option"
                :key="option.id"
              >{{option.isAnswer?letter[keys]:''}}</span></div>
          </div>
        </div>
        <div class="topic">
          <div class="topic-title">多选题（共{{multipleChoiceData.length}}题）</div>
          <div
            class="option"
            v-for="(item,index) in multipleChoiceData"
            :key="index"
          >
            <div class="option-title">
              <div>
                <span>{{index+1}}、</span>
                <span v-html="item.onlineQuestion.content"></span>
                <span>({{Number(item.onlineQuestion.grade)}}分)</span>
              </div>
              <span @click="delQuestion(item.id)">删除</span>
            </div>
            <div
              v-for="(option,keys) in item.onlineQuestion.option"
              :key="option.id"
            ><input
                type="radio"
                value="0"
                disabled
              ><span>{{letter[keys]}}.{{option.title}}</span></div>
            <div class="answer">正确答案:<span
                v-for="(option,keys) in item.onlineQuestion.option"
                :key="option.id"
              >{{option.isAnswer?letter[keys]:''}}</span></div>
          </div>

        </div>
        <div class="topic">
          <div class="topic-title">判断题（共{{judgeData.length}}题）</div>
          <div
            class="option"
            v-for="(item,index) in judgeData"
            :key="index"
          >
            <div class="option-title">
              <div>
                <span>{{index+1}}、</span>
                <span v-html="item.onlineQuestion.content"></span>
                <span>({{Number(item.onlineQuestion.grade)}}分)</span>
              </div>
              <span @click="delQuestion(item.id)">删除</span>
            </div>
            <div
              v-for="(option,keys) in item.onlineQuestion.option"
              :key="option.id"
            ><input
                type="radio"
                value="0"
                disabled
              ><span>{{letter[keys]}}.{{option.title}}</span></div>
            <div class="answer">正确答案:<span
                v-for="(option,keys) in item.onlineQuestion.option"
                :key="option.id"
              >{{option.isAnswer?letter[keys]:''}}</span></div>
          </div>
        </div>
      </div>

      <div class="course_info">
        <div class="panel-title">
          <p>试卷组成结果</p>
        </div>
      </div>

      <div class="tips-info">
        <p>试卷总题数<span>{{ questionStatistics.count }}</span>道，共<span>{{ questionStatistics.grade }}</span>分</p>
        <p>注：组卷总分尽量以整100分为准，如组卷总分不等于100分，则学生测试结果将换算至百分制得分</p>
      </div>
      <div class="btn-group">
        <span
          class="submit"
          @click="saveFormInfo"
        >提交</span>
      </div>
    </div>
    <!--试题选择弹窗-->
    <div
      id="c-panel"
      :style="classShowAddWindow"
    >
      <div id="c-panel-bg"></div>
      <div class="c-content">
        <form
          id="search"
          onsubmit="return false;"
        >
          <select
            id=""
            class="s-text"
            v-model="queryInfo.questionType"
          >
            <option value="">试题类型</option>
            <option value="1">单选题</option>
            <option value="2">多选题</option>
            <option value="3">判断题</option>
          </select>
          <input
            type="text"
            class="s-text"
            placeholder="试题题干"
            autocomplete="off"
            v-model="queryInfo.content"
          >

          <input
            type="submit"
            class="s-btn1"
            value="查询"
            @click="getQuestionInfo"
          >
          <span
            class="close-cpanel"
            @click="hideAddWindow"
          ></span>
        </form>
        <div id="uList">
          <table>
            <tbody>
              <tr class="l_header">
                <th>类型</th>
                <th>题干</th>
                <th>分值</th>
                <th class="action">操作</th>
              </tr>
              <tr
                class="item"
                v-for="(item,index) in tableData"
                :key="index"
              >
                <td>{{formatType(item.questionType)}}</td>
                <td v-html="item.content"></td>
                <td>{{item.grade}}</td>
                <td class="action">
                  <a
                    class="a-button"
                    href="javascript:;"
                    @click="addQuestion(item.id)"
                  >选择</a>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 分页 -->
          <pagination
            :cur='pageInfo.page'
            :all='pageInfo.all'
            :totalData="pageInfo.totalData"
            :callback="pageCallback"
          ></pagination>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'

export default {
  name: 'OnlineExam',
  components: {
    Pagination
  },
  props: ['lessonInfo'],
  data() {
    return {
      tableData: [],
      tableDataCount: 0,
      totalScore: 0,
      manager: {},
      classShowAddWindow: {
        visibility: 'hidden'
      },
      formInfo: {
        id: null,
        lessonOnline_id: Number(this.lessonInfo.id),
        title: this.$route.query.title,
        des: '',
        examMinutes: '',
        startTime: '',
        endTime: '',
        answerTime: ''
      },
      letter: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'],
      queryInfo: {
        page: 1,
        size: 10,
        lessonOnline_id: this.lessonInfo.id,
        questionType: '',
        content: '',
        bank: 1
      },
      examQuestion: [],
      examQuestionOption: []
    }
  },
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    singleChoiceData () {
      const data = []
      for (let i = 0; i < this.examQuestion.length; i++) {
        if (this.examQuestion[i].onlineQuestion.questionType === 1) {
          const question = this.examQuestion[i].onlineQuestion
          question.option = []
          for (let j = 0; j < this.examQuestionOption.length; j++) {
            if (this.examQuestionOption[j].question_id === question.id) {
              question.option.push(this.examQuestionOption[j])
            }
          }
          data.push(this.examQuestion[i])
        }
      }
      return data
    },
    multipleChoiceData () {
      const data = []
      for (let i = 0; i < this.examQuestion.length; i++) {
        if (this.examQuestion[i].onlineQuestion.questionType === 2) {
          const question = this.examQuestion[i].onlineQuestion
          question.option = []
          for (let j = 0; j < this.examQuestionOption.length; j++) {
            if (this.examQuestionOption[j].question_id === question.id) {
              question.option.push(this.examQuestionOption[j])
            }
          }
          data.push(this.examQuestion[i])
        }
      }
      return data
    },
    judgeData () {
      const data = []
      for (let i = 0; i < this.examQuestion.length; i++) {
        if (this.examQuestion[i].onlineQuestion.questionType === 3) {
          const question = this.examQuestion[i].onlineQuestion
          question.option = []
          for (let j = 0; j < this.examQuestionOption.length; j++) {
            if (this.examQuestionOption[j].question_id === question.id) {
              question.option.push(this.examQuestionOption[j])
            }
          }
          data.push(this.examQuestion[i])
        }
      }
      return data
    },
    questionStatistics () {
      const data = {
        count: 0,
        grade: 0
      }
      for (let i = 0; i < this.examQuestion.length; i++) {
        data.count += 1
        data.grade += parseFloat(this.examQuestion[i].onlineQuestion.grade)
      }
      return data
    },
    nowDate() {
      const date = new Date()
      var year = date.getFullYear() // 获取当前年
      var mon = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)//
      var dat = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

      return year + '-' + mon + '-' + dat + 'T00:00:00'
    }
  },
  methods: {
    formatNum(num, val) {
      var value = val ? val.length : 0
      return Number(num - value)
    },
    formatType(code) {
      if (code === 1) {
        return '单选题'
      } else if (code === 2) {
        return '多选题'
      } else if (code === 3) {
        return '判断题'
      }
    },
    getUrlKey(name) {
      const url = window.location.href
      const dzUrl = url.split('#')[0]
      if (dzUrl.split('?').length <= 1) {
        return ''
      }
      const csArr = dzUrl.split('?')[1].split('&')
      const cs = {}
      for (let i = 0; i < csArr.length; i++) {
        cs[csArr[i].split('=')[0]] = csArr[i].split('=')[1]
      }
      return cs[name]
    },
    // 获取课程测试信息
    async getExamCourseInfo() {
      await this.$http.get('/online_exam/' + this.formInfo.id + '/').then((data) => {
        if (data.id) {
          this.formInfo.title = data.title
          this.formInfo.des = data.des
          this.formInfo.examMinutes = data.examMinutes
          this.formInfo.startTime = data.startTime
          this.formInfo.endTime = data.endTime
          this.formInfo.answerTime = data.answerTime
        }
      }).catch(() => {
        this.$layer.msg('获取测试信息失败！')
      })
    },
    // 获取题库信息
    async getQuestionInfo() {
      await this.$http.get('/online_question/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取题库信息失败！')
      })
    },
    // 显示单选弹窗
    showAddWindow() {
      this.queryInfo.questionType = ''
      this.queryInfo.content = ''
      this.tableData = []
      this.tableDataCount = 0
      this.classShowAddWindow = {
        visibility: 'visible'
      }
      this.getQuestionInfo()
    },
    // 隐藏单选弹窗
    hideAddWindow() {
      this.classShowAddWindow = {
        visibility: 'hidden'
      }
    },
    // 保存课程测试信息
    async saveFormInfo() {
      if (!this.formInfo.title) {
        this.$layer.msg('测试标题不得为空！')
        return
      }
      if (!this.formInfo.examMinutes) {
        this.$layer.msg('测试时间不得为空！')
        return
      }
      if (this.formInfo.examMinutes > 300) {
        this.$layer.msg('测试时间需小于300分钟！')
        return
      }
      if (Number(this.formInfo.examMinutes) < 0) {
        this.$layer.msg('测试时间不得小于0！')
        return
      }

      if (!this.formInfo.startTime) {
        this.$layer.msg('测试开始时间不得为空！')
        return
      }
      if (this.formInfo.startTime < this.lessonInfo.startTime) {
        this.$layer.msg('测试开始时间不得小于课程开始时间！')
        return
      }
      if (this.formInfo.startTime > this.lessonInfo.endTime) {
        this.$layer.msg('测试开始时间不得大于课程结束时间！')
        return
      }

      if (!this.formInfo.endTime) {
        this.$layer.msg('测试截止时间不得为空！')
        return
      }
      if (this.formInfo.endTime < this.formInfo.startTime) {
        this.$layer.msg('测试截止时间不得小于测试开始时间！')
        return
      }
      if (this.formInfo.endTime > this.lessonInfo.endTime) {
        this.$layer.msg('测试截止时间不得大于课程结束时间！')
        return
      }
      if (!this.formInfo.answerTime) {
        this.$layer.msg('显示成绩时间不得为空！')
        return
      }
      if (this.formInfo.answerTime < this.formInfo.endTime) {
        this.$layer.msg('显示成绩时间不得小于测试截止时间！')
        return
      }
      if (!this.formInfo.des) {
        this.$layer.msg('测试说明不得为空！')
        return
      }
      this.$http.put('/online_exam/' + this.formInfo.id + '/', this.formInfo).then((data) => {
        if (data.id) {
          this.$router.push('/online/content?id=' + this.lessonInfo.id)
          this.$layer.msg('保存成功！')
        }
      }).catch(() => {
        this.$layer.msg('保存失败！')
      })
    },
    // 分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.getQuestionInfo()
    },
    // 弹窗中 选择试题
    async addQuestion(id) {
      this.$http.get('/online_exam_question/', {
        params: {
          onlineExam_id: this.formInfo.id,
          onlineQuestion_id: id
        }
      }).then((data) => {
        if (data.results.length > 0) {
          this.$layer.msg('当前测试下已经存在该试题！')
        } else {
          this.$http.post('/online_exam_question/', {
            onlineExam_id: this.formInfo.id,
            onlineQuestion_id: id
          }).then((data) => {
            if (data.id) {
              this.$layer.msg('添加试题成功！')
              this.searchExamQuestion()
            }
          }).catch(() => {
            this.$layer.msg('添加试题失败！')
          })
        }
      }).catch(() => {
        this.$layer.msg('添加试题失败！')
      })
    },
    // 加载试题列表
    searchExamQuestion () {
      this.$http.get('/online_exam_question/', {
        params: {
          onlineExam_id: this.formInfo.id,
          page: 1,
          size: 10000
        }
      }).then((data) => {
        this.examQuestion = data.results
      }).catch(() => {
        this.$layer.msg('加载试题失败！')
      })
      this.$http.get('/online_question_option/', {
        params: {
          exam_id: this.formInfo.i,
          page: 1,
          size: 10000
        }
      }).then((data) => {
        this.examQuestionOption = data.results
      }).catch(() => {
        this.$layer.msg('加载试题失败！')
      })
    },
    // 删除试题
    delQuestion (id) {
      this.$http.delete('/online_exam_question/' + id + '/').then((data) => {
        this.searchExamQuestion()
      }).catch(() => {
        this.$layer.msg('删除试题失败！')
      })
    }
  },
  mounted() {
    this.getExamCourseInfo()
    this.searchExamQuestion()
  },
  created() {
    this.formInfo.id = this.getUrlKey('exam_id')
  }
}
</script>

<style scoped src="@/assets/css/project-detail.css"></style>

<style lang="less" scoped>
#center {
  width: 1900px;
}
#panel {
  min-width: 1200px;
}
.panel-content {
  width: 1200px;
  margin: 10px auto 0;
  padding: 20px 40px;
  overflow: hidden;
  box-sizing: border-box;
}

.course_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .panel-title {
    p {
      display: inline-block;
      margin-right: 20px;

      &:nth-child(2) {
        color: #999;
        font-size: 16px;
      }
    }
  }
  .course_btn {
    div {
      margin-left: 20px;
      margin-bottom: 0;
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      &:first-child {
        background: #25c7a8;
      }
      &:nth-child(2) {
        border: 1px solid #73D6CA;
        color: #73D6CA;
        background: #fff;
      }
    }
  }
}
.crumb_nav {
  color: #999;
  margin-top: 20px;
}
.add-btn {
  width: unset;
  height: unset;
  line-height: normal;
}
#list {
  margin-bottom: 80px;
}
.list {
  margin-bottom: 80px;
  border: 1px solid #eee;
  padding: 50px 20px;
  box-sizing: border-box;
}
#itemForm {
  .item {
    margin-bottom: 20px;
    .label {
      font-size: 15px;
      line-height: 30px;
      color: #666;
      margin-right: 20px;
      width: 100px;
      display: inline-block;
      text-align: right;
    }
    .minute {
      border: 1px solid #e6e6e6;
      background: #f5f7fc;
      height: 30px;
      input {
        width: 160px;
        height: 30px;
        border: none;
      }
      span {
        color: red;
        font-size: 12px;
        margin-right: 10px;
      }
    }
    .item-minute {
      display: flex;
      margin-right: 70px;
    }
    input {
      width: 200px;
      height: 30px;
      padding-left: 10px;
      outline: none;
      box-sizing: border-box;
    }

    label {
      font-size: 15px;
      color: #666;
      margin-right: 20px;
      display: inline-flex;
      justify-content: flex-start;
      align-items: center;
      input[type="checkbox"] {
        width: 13px;
        height: 13px;
        margin-right: 5px;
        border: 1px solid #e6e6e6;
        box-sizing: border-box;
      }
    }
    input[type="checkbox"] {
      width: unset;
      height: unset;
    }

    textarea {
      width: 910px;
      padding: 10px;
      height: 100px;
      outline: none;
      box-sizing: border-box;
    }
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3) {
      display: flex;
    }
    &:nth-child(2),
    &:nth-child(3) {
      width: 1030px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    &:last-child {
      width: 1030px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
.table-title {
  font-size: 16px;
  color: #10b67c;
  margin-bottom: 15px;
}
.add_line_btn {
  width: 100%;
  text-align: right;
  margin: 10px 0;
  .add-btn {
    display: inline-block;
    background: none;
    border: 1px solid #73D6CA;
    color: #73D6CA;
    padding: 5px 10px;
  }
}
.table-tips-info {
  color: #999;
  margin-top: 10px;
}
.tips-info {
  width: 100%;
  padding: 20px;
  border: 1px solid #25c7a8;
  box-sizing: border-box;
  p {
    font-size: 16px;
    color: #555;
    margin-bottom: 20px;
    span {
      color: red;
      font-weight: bold;
      padding: 0 10px;
    }
    &:last-child {
      color: #999;
    }
  }
}
.btn-group {
  margin-top: 70px;
  text-align: center;
  span {
    display: inline-block;
    font-size: 16px;
    color: #fff;
    background: #999;
    padding: 10px 30px;
    border-radius: 5px;
    cursor: pointer;
    &:last-child {
      margin-left: 20px;
      background: #73D6CA;
    }
  }
}
.topic {
  margin-bottom: 20px;
  .topic-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .option {
    margin-left: 30px;
    margin-bottom: 20px;
    > div {
      font-size: 14px;
      margin-bottom: 10px;
      color: #555;
      input {
        margin-right: 10px;
      }
    }
    .option-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      > div {
        span {
          display: inline-block;
          font-size: 15px;
          &:nth-child(3) {
            margin-left: 10px;
          }
        }
      }
      > span {
        border: 1px solid red;
        background: #fff;
        color: red;
        padding: 5px 10px;
        border-radius: 5px;
        cursor: pointer;
      }
    }
    .answer {
      color: green;
      margin-top: 20px;
    }
  }
}
.c-content {
  margin: 0;
  transform: translate(-50%, -50%);
}
.s-input,
.s-select,
.s-checkbox {
  border: 1px solid #e6e6e6;
  border-right: none;
  background: #f5f7fc;
  height: 32px;
  line-height: 34px;
  text-indent: 0;
  width: auto;
  border-radius: 2px;
  display: inline-block;
  vertical-align: middle;
}
#c-panel {
  z-index: 2;
}
.tips {
  span {
    display: block;
    color: #e12d2d;
  }
}
</style>
